import { useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDebouncedValue } from "../../../../../hooks/useDebounce";
import { useUnityList } from "../../../../../services/api-tansquery/unity-list";
import { Unity } from "../../../../../@types/unity";

type Props = {
    field: ControllerRenderProps<{
        titulo?: string;
        texto?: string;
        data?: string; // formato "YYYY-MM-DD"
        ativo?: boolean;
        presencial?: boolean;
        reagendar_presencial?: boolean;
        online?: boolean;
        geral?: boolean;
        slug_unidade?: string;
    }, "slug_unidade">;
    fieldState: ControllerFieldState;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export default function UnityField({ field, fieldState, style, disabled }: Props) {
    const [search, setSearch] = useState<string>();
    const debouncedSearch = useDebouncedValue(search, 500);
    const { data: unityList, isLoading } = useUnityList({
        search: debouncedSearch, page: 1, ativo: true, items_size: 1000
    });

    function handleInputChange(_, value: string, reason: string) {
        if (reason === "input") {
            setSearch(value.trim() === "" ? undefined : value);
        }
    }

    function handleSelectChange(_, newValue: Unity | null) {
        if (!newValue) {
            field.onChange("");
        } else {
            field.onChange(newValue.slug_unidade);
        }

    }

    return (
        <Autocomplete
            disabled={disabled}
            style={style}
            freeSolo={false}
            options={unityList?.results || []}
            value={unityList?.results.find((item) => item.slug_unidade === field.value) || null}
            getOptionLabel={(option) => `${option.nome}`}
            getOptionSelected={(option, value) => option.slug_unidade === value.slug_unidade}
            onChange={handleSelectChange}
            onInputChange={handleInputChange}
            loading={isLoading}
            loadingText="Carregando unidades..."
            noOptionsText="Nenhuma unidade encontrada"
            renderInput={(params) => (
                <TextField
                    {...params}
                    required={!disabled}
                    label="Unidade"
                    variant="outlined"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message || "Escolha a unidade onde o cancelamento se aplica."}
                    InputProps={{
                        ...params.InputProps,
                        required: false,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
